// Portfolio logo/wordmark marquee — sits directly below the hero as a
// "built this way" strip. Companies with a logo render it (monochrome white to
// match the dim wordmark treatment); the rest fall back to a serif name until
// their logo is added.

const COMPANIES = [
  { name: "Naehas", logo: "/logos/naehas.png" },
  { name: "Zenarate" },
  { name: "Zenafide" },
  { name: "Lexafide", logo: "/logos/lexafide.png" },
  { name: "Stellaforce" },
];

export default function LogoMarquee() {
  const items = [...COMPANIES, ...COMPANIES, ...COMPANIES];
  return (
    <section
      data-testid="logo-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-noir py-7 [mask-image:linear-gradient(to_right,transparent,black_12%,black_88%,transparent)]"
    >
      <div className="flex w-max animate-marquee items-center gap-20">
        {items.map((c, i) =>
          c.logo ? (
            <img
              key={i}
              src={c.logo}
              alt={c.name}
              loading="lazy"
              decoding="async"
              className="h-7 w-auto shrink-0 opacity-30 [filter:brightness(0)_invert(1)] md:h-8"
            />
          ) : (
            <span
              key={i}
              className="whitespace-nowrap font-serif text-3xl tracking-tight text-cream/25 md:text-4xl"
            >
              {c.name}
            </span>
          )
        )}
      </div>
    </section>
  );
}
